import React from 'react';
import Context from '../../assets/js/Context';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import { Row, Col, Image, Badge } from 'react-bootstrap';
import "react-datepicker/dist/react-datepicker.css";
import Component from "@reactions/component";
import { SideSheet, Pane, Dialog } from 'evergreen-ui';
import { ToastContainer, toast } from 'react-toastify';
import SearchIcon from '@material-ui/icons/Search';
import DeleteForeverIcon from '@material-ui/icons/Cancel';
import MultiSelect from "@kenshooui/react-multi-select";
import DoneAllIcon from '@material-ui/icons/DoneAll';
import Edit from '@material-ui/icons/Edit';
import ItemsImg from '../../assets/img/items.jpg';
import CategoryIcon from '@material-ui/icons/Category';
import Undo from '@material-ui/icons/Undo';
import 'react-toastify/dist/ReactToastify.css';
import qs from 'qs';
import * as moment from "moment-timezone";
import Login from '../common/login';
import exportFromJSON from 'export-from-json'

const cookies = new Cookies();
let id = 0;

// ═══════════════════════ نظام التصميم ═══════════════════════
// لغة بصرية موحّدة مع «كشوفات الإنجاح» و«موازِن التوصيل»:
// حبر داكن للأسطح القيادية، أخضر بترولي للفعل، طوبي للتنبيه،
// أرقام جدولية بكل مكان يُقرأ فيه رقم.
const T = {
    ink: '#16202E', ink2: '#64748B', ink3: '#94A3B8',
    line: '#E6EBF2', wash: '#F8FAFC', paper: '#FFFFFF',
    pick: '#0E7C6B', ok: '#12734C', warn: '#B4530C', bad: '#C0341D',
    info: '#2450C8', device: '#6D4AA8',
};

// الأزرار القديمة تمرّر ألوان bootstrap — نترجمها للّوحة الجديدة
// كي لا نضطر لتعديل كل نداء بالملف.
const BTN = {
    '#48bb78': T.pick, '#38a169': T.pick, '#4299e1': T.ink,
    '#9f7aea': T.device, '#dd6b20': T.warn, '#fc8181': T.bad,
    '#a0aec0': '#8FA0B5', '#ed8936': T.warn, '#e53e3e': T.bad,
};

const S = {
    page: { backgroundColor: T.wash, minHeight: '100vh', direction: 'rtl', color: T.ink,
        fontFamily: "'Segoe UI','Noto Kufi Arabic',Tahoma,sans-serif", fontSize: '14px' },

    topBar: { background: T.ink, color: '#E8EEF6', padding: '16px 24px',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        gap: '14px', flexWrap: 'wrap' },
    topTitle: { margin: 0, fontSize: '21px', fontWeight: '800', letterSpacing: '-0.01em' },

    statsBar: { display: 'flex', gap: '1px', background: T.line,
        borderBottom: `1px solid ${T.line}` },
    statCard: (color) => ({ flex: '1 1 130px', padding: '13px 16px', textAlign: 'right',
        backgroundColor: T.paper, borderTop: `3px solid ${color}` }),
    statValue: (color) => ({ fontSize: '25px', fontWeight: '800', color,
        letterSpacing: '-0.02em', fontVariantNumeric: 'tabular-nums', lineHeight: 1.15 }),
    statLabel: { fontSize: '11px', color: T.ink2, fontWeight: '700', letterSpacing: '0.1em' },

    card: { backgroundColor: T.paper, border: `1px solid ${T.line}`, borderRadius: '12px',
        padding: '16px 18px', marginBottom: '14px' },
    cardTitle: { fontSize: '11px', fontWeight: '700', color: T.ink2, letterSpacing: '0.12em',
        marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' },

    input: { border: `1px solid #CBD5E1`, borderRadius: '8px', padding: '9px 13px',
        fontSize: '15px', outline: 'none', width: '100%', backgroundColor: T.paper,
        color: T.ink, fontFamily: 'inherit', fontVariantNumeric: 'tabular-nums' },

    btn: (bg) => ({ backgroundColor: BTN[bg] || bg, color: 'white', border: 'none',
        borderRadius: '8px', padding: '9px 18px', fontSize: '14px', fontWeight: '700',
        cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '7px',
        fontFamily: 'inherit', whiteSpace: 'nowrap' }),
    btnDisabled: { opacity: 0.45, cursor: 'not-allowed' },

    select: { border: `1px solid #CBD5E1`, borderRadius: '8px', padding: '9px 12px',
        fontSize: '14px', outline: 'none', backgroundColor: T.paper, minWidth: '140px',
        fontWeight: '600', color: T.ink, fontFamily: 'inherit' },

    table: { width: '100%', borderCollapse: 'collapse', fontSize: '13.5px' },
    th: { backgroundColor: T.paper, color: T.ink2, padding: '9px 10px', textAlign: 'center',
        fontSize: '11px', fontWeight: '700', letterSpacing: '0.05em',
        borderBottom: `1px solid ${T.line}`, position: 'sticky', top: 0, zIndex: 2,
        whiteSpace: 'nowrap' },
    td: { padding: '9px 10px', textAlign: 'center', fontSize: '13.5px', color: T.ink,
        borderBottom: '1px solid #F1F5F9', fontVariantNumeric: 'tabular-nums' },

    scanInput: { border: `2px solid ${T.pick}`, borderRadius: '10px', padding: '13px 18px',
        fontSize: '21px', fontWeight: '800', textAlign: 'center', outline: 'none',
        width: '100%', backgroundColor: '#F2F9F6', color: T.ink,
        fontFamily: 'inherit', fontVariantNumeric: 'tabular-nums' },

    progressBar: () => ({ height: '8px', borderRadius: '4px', backgroundColor: T.line,
        overflow: 'hidden', position: 'relative' }),
    progressFill: (pct, color) => ({ height: '100%', width: `${pct}%`, backgroundColor: color,
        borderRadius: '4px', transition: 'width 0.5s ease' }),

    scanLogItem: (status) => ({ display: 'flex', gap: '11px', alignItems: 'center',
        padding: '8px 13px', borderRadius: '8px', marginBottom: '5px', fontSize: '13.5px',
        backgroundColor: status === 'success' ? '#F1F9F5' : status === 'error' ? '#FDECE9' : '#FFF8EE',
        borderRight: `3px solid ${status === 'success' ? T.ok : status === 'error' ? T.bad : T.warn}` }),

    deviceBadgeMatched: { display: 'inline-flex', alignItems: 'center', gap: '4px', margin: '2px',
        padding: '2px 10px', borderRadius: '999px', fontSize: '12px', fontWeight: '700',
        backgroundColor: '#F1F9F5', color: T.ok, border: '1px solid #BFE3D2',
        fontVariantNumeric: 'tabular-nums' },
    deviceBadgePending: { display: 'inline-flex', alignItems: 'center', gap: '4px', margin: '2px',
        padding: '2px 10px', borderRadius: '999px', fontSize: '12px', fontWeight: '700',
        backgroundColor: '#FDECE9', color: T.bad, border: '1px solid #F3C4BB',
        fontVariantNumeric: 'tabular-nums' },
    deviceBadgeReplacement: { display: 'inline-flex', alignItems: 'center', gap: '4px', margin: '2px',
        padding: '2px 10px', borderRadius: '999px', fontSize: '12px', fontWeight: '700',
        backgroundColor: '#F4F7FD', color: T.info, border: '1px solid #D3DEF2' },

    // حالة الصف تُقرأ من الشريط الأيمن لا من خلفية صارخة
    rowMatched: { borderRight: `3px solid ${T.ok}` },
    rowPending: { borderRight: `3px solid ${T.bad}`, backgroundColor: '#FEF7F6' },
    rowHome: { borderRight: '3px solid transparent' },
    rowHavDone: { borderRight: `3px solid ${T.warn}`, backgroundColor: '#FFFBF3' },
    rowReplacement: { borderRight: `3px solid ${T.info}` },
};

// أعمدة الجدول — عروض ثابتة ومحاذاة حسب نوع المحتوى.
// النصوص الطويلة تُحاذى لليمين، والأرقام والأزرار للوسط.
const COLS = [
    { key: 'id', t: 'رقم الوصل', w: '92px' },
    { key: 'date', t: 'التاريخ', w: '96px' },
    { key: 'gov', t: 'العنوان', w: '100px' },
    { key: 'price', t: 'السعر', w: '66px' },
    { key: 'safee', t: 'الصافي', w: '72px' },
    { key: 'product', t: 'المنتج', w: '210px', align: 'right' },
    { key: 'device', t: 'الجهاز', w: '132px' },
    { key: 'calls', t: 'التبليغ', w: '70px' },
    { key: 'calls_d', t: 'تفاصيل', w: '180px', align: 'right' },
    { key: 'notes', t: 'ملاحظات', w: '200px', align: 'right' },
    { key: 'items', t: 'المواد', w: '66px' },
    { key: 'act', t: 'إجراءات', w: '104px' },
];

// ما لا تقدر عليه الأنماط السطرية: تحويم · تركيز · ثبات الترويسة · تفضيل الحركة
const PAGE_CSS = `
.lb button { transition: filter .15s ease; }
.lb button:hover:not(:disabled) { filter: brightness(1.08); }
.lb button:focus-visible, .lb input:focus-visible, .lb select:focus-visible {
  outline: 2px solid ${T.info}; outline-offset: 2px; }
.lb input:focus, .lb select:focus { border-color: ${T.info}; }
.lb tbody tr:hover td { background-color: #F6F9FC; }
.lb .lb-sec { border-bottom: 1px solid ${T.line}; background: ${T.paper}; }
.lb .lb-panel { border-radius: 12px; border: 1px solid ${T.line}; background: ${T.paper};
  overflow: hidden; margin-bottom: 14px; }
.lb .lb-panel-head { display: flex; align-items: center; gap: 10px; padding: 10px 16px;
  background: ${T.wash}; border-bottom: 1px solid ${T.line};
  font-size: 11px; font-weight: 700; letter-spacing: .12em; color: ${T.ink2}; }
.lb .lb-step { font-size: 11px; font-weight: 800; letter-spacing: .1em; color: ${T.warn};
  display: flex; align-items: center; gap: 8px; margin-bottom: 9px; }
.lb .lb-step i { width: 20px; height: 20px; border-radius: 50%; background: ${T.warn};
  color: #fff; font-style: normal; font-size: 11px; display: flex;
  align-items: center; justify-content: center; }
.lb .lb-group { display: flex; align-items: center; gap: 8px; padding-left: 14px;
  margin-left: 6px; border-left: 1px solid ${T.line}; }
.lb .lb-group:last-child { border-left: none; }
/* ⚠️ ولا سكرول عمودي داخلي — الجدول يُعرض كاملاً والصفحة تنزل.
   الأفقي auto للشاشات الضيقة فقط. */
.lb .lb-tablewrap { border: 1px solid ${T.line}; border-radius: 12px;
  overflow-x: auto; overflow-y: visible; background: ${T.paper}; }
.lb .lb-tablewrap table { table-layout: fixed; }
.lb .lb-tablewrap td { word-break: break-word; }
/* الترويسة تلتصق بأعلى النافذة لأن ما فيه حاوية تمرير */
.lb .lb-tablewrap th { box-shadow: 0 1px 0 ${T.line}; }
.lb .lb-actions { display: flex; align-items: center; justify-content: center; gap: 6px; }
.lb .lb-txt { text-align: right; }
.lb .lb-lock { display: inline-flex; align-items: center; gap: 7px; padding: 3px 12px;
  border-radius: 999px; font-size: 12px; font-weight: 700;
  background: rgba(255,255,255,.1); color: #C6D3E3; }
@media (prefers-reduced-motion: reduce) {
  .lb *, .lb *::before { transition: none !important; animation: none !important; }
}
`;


class Selles_Reports extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            from: new Date(), to: new Date(),
            spin: false, serch: false,
            total: '', total_items: 0, total_orders: 0,
            items_cost: 0, orders_cost: 0,
            ordes2: [], items: [],
            id: '', cash: '', cash_orders: '',
            total_price: "", t_safee: 0, createdAt: '',
            selectedItems: [{}, {}],
            datesSummary: {}, dateLocationSummary: {}, itemsSummary: {},
            showDeviceScanner: false,
            scannedDevices: {},
            scanLog: [],
            totalPhoneDevices: 0,
            matchedDevicesCount: 0,
            rawOrders: [],
            deviceFilter: 'all',
            scanLogAll: false,
            is_send: false,

            // ===== لوحة الراجع الجزئي (داخل الماسح) =====
            // العدّ للأجهزة **يُشتقّ من المسح** لا يُكتب: الماسح هو
            // المدخل الطبيعي عند استلام الراجع، والرقم المكتوب يدوياً
            // يفترق عمّا وصل فعلاً.
            prPanel: false,
            prOrderId: '',
            prData: null,      // ردّ GET partial-return/:orderId
            prPrice: '',
            prQty: {},         // المواد المنزلية: { orderItemId: عدد }
            prFree: {},        // وحدات بند جهاز بلا ربط: { orderItemId: عدد }
            prDevs: [],        // المسحوبة بالمسح: [{ id, sn, composite_name, orderItemId, component_name, condition }]
            prBusy: false,
        }
        // بنود الطلبات وأجهزتها المربوطة + الراجع المسجَّل.
        // تُملأ قبل بناء الصفوف — انظر Orders().
        this.prMeta = {};
        this.prMetaError = null;
        const urlParams = new URLSearchParams(window.location.search);
        let Getid = urlParams.get('id');
        this.setState({ id: Getid });
        this.Orders(Getid);
        id = Getid;
        // تحميل السجل من localStorage
        this.state.scanLog = this.loadScanLog(Getid);
    }

    // === localStorage helpers ===
    getScanLogKey(listId) { return `scanLog_list_${listId || id}`; }

    loadScanLog(listId) {
        try {
            const data = localStorage.getItem(this.getScanLogKey(listId));
            return data ? JSON.parse(data) : [];
        } catch (e) { return []; }
    }

    saveScanLog(log) {
        try { localStorage.setItem(this.getScanLogKey(), JSON.stringify(log)); } catch (e) { console.log(e); }
    }

    clearScanLogStorage() {
        try { localStorage.removeItem(this.getScanLogKey()); } catch (e) { console.log(e); }
    }

    removeScanLogByOrderId(orderId) {
        const filtered = this.state.scanLog.filter(l => l.orderId !== orderId);
        this.setState({ scanLog: filtered });
        this.saveScanLog(filtered);
    }

    componentDidMount() {
        let header = { "Content-Type": "application/json", token: cookies.get("token") };
        axios.get(host + `dashbord/shiper/all/`, { headers: header })
            .then(res => { this.setState({ shiper: res.data.shiper }) })
            .catch(error => { console.log(error.response) });
        const urlParams = new URLSearchParams(window.location.search);
        let Getid = urlParams.get('id');
        this.setState({ id: Getid });
        this.Orders(Getid);
        id = Getid;
    }

    edit(obj, id) {
        let price = document.getElementById('Editprice').value;
        let notes = document.getElementById('Editnotes').value;
        var header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        let formData = new FormData();
        formData.append("price", price); formData.append("notes", notes); formData.append("is_edited", 1); formData.append("items", JSON.stringify(obj));
        axios({ url: host + `dashbord/order/edit/${id}`, method: "POST", data: formData, headers: header })
            .then(response => { this.componentDidMount(); toast.success('تم التعديل بنجاح', { position: "bottom-center", autoClose: 3000 }); })
            .catch(error => { console.log(error.response.data.message) })
    }

    recjeted(data, price, id) {
        var header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        let formData = new FormData();
        formData.append("data", JSON.stringify(data)); formData.append("price", Number(price));
        axios({ url: host + `dashbord/rejected/orders/update/${id}`, method: "post", data: formData, headers: header })
            .then(response => { this.componentDidMount(); toast.success('تم تعديل الطلب', { position: "bottom-center", autoClose: 3000 }); return true; })
            .catch(error => { console.log(error) })
    }

    // ============================================================
    //  لوحة الراجع الجزئي — مدخلها الماسح
    //
    //  ===== لماذا المسح لا الكتابة؟ =====
    //  الفني يستلم الراجع والماسح بيده. الرقم المكتوب يدوياً يقول
    //  «رجع اثنان» بلا أن يقول **أيّهما**، والجهازان قد يختلفان
    //  تكلفةً وصنفاً وحالة. المسح يجيب الاثنين معاً: العدد والهوية.
    //
    //  فالعدد **مشتقّ من عدد المسحات**، لا يُكتب ولا يُخزَّن بجانبها.
    // ============================================================
    prReset() {
        this.setState({
            prOrderId: '', prData: null, prPrice: '',
            prQty: {}, prFree: {}, prDevs: [], prBusy: false,
        });
    }

    prFocus(elId) {
        setTimeout(() => { const el = document.getElementById(elId); if (el) { el.value = ''; el.focus(); } }, 60);
    }

    // فتح الطلب برقم الوصل.
    // noAdd يمنع محاولة الإضافة ثانيةً بعد إضافة ناجحة — بلاه تدور
    // الدالة على نفسها لو بقي الوصل غائباً عن الخريطة لأي سبب.
    prOpenOrder(raw, noAdd) {
        const oid = Number(String(raw || '').trim());
        if (!oid) { toast.error('اكتب رقم الوصل', { position: "bottom-center" }); return; }

        const header = { "Content-Type": "application/json", token: cookies.get("token") };
        this.setState({ prBusy: true });

        axios.get(host + `dashbord/list/partial-return/${oid}`, { headers: header })
            .then(res => {
                const d = this.unwrapRes(res);

                if (d.partial_return) {
                    this.setState({ prBusy: false });
                    toast.error(`الوصل ${oid}: سُجّل عليه راجع جزئي مسبقاً`, { position: "bottom-center", autoClose: 5000 });
                    return;
                }
                if (d.replacement) {
                    this.setState({ prBusy: false });
                    toast.error(`الوصل ${oid}: طلب استبدال — يُعالَج في رواجع الاستبدالات`, { position: "bottom-center", autoClose: 5000 });
                    return;
                }

                // ===== الوصل ليس في هذه القائمة =====
                //
                // بلا قائمة إطلاقاً ⟵ **يُضاف لهذه القائمة**. الفني
                // يستلم راجعاً لم يُسجَّل بعد؛ إجباره على إضافته من زر
                // آخر أولاً يكسر تدفّق الاستلام بلا سبب.
                //
                // في قائمة أخرى ⟵ لا يُضاف. الطلب لا يكون في قائمتين،
                // وأجهزته وصلت مع شحنة تلك القائمة لا هذه.
                if (!this.prMeta || !this.prMeta[oid]) {
                    if (d.list_id) {
                        this.setState({ prBusy: false });
                        const where = `قائمة ${d.list_id}${d.list_name ? ' — ' + d.list_name : ''}`;
                        if (d.list_is_send) {
                            toast.error(`الوصل ${oid} في ${where} وهي أُدخلت للمخزن — لا يمكن تسجيل راجع عليها`, { position: "bottom-center", autoClose: 8000 });
                            return;
                        }
                        toast.error(
                            <span>
                                الوصل {oid} في <b>{where}</b> — مو بهذه القائمة.{' '}
                                <a href={`/list?id=${d.list_id}`} style={{ color: '#fff', textDecoration: 'underline', fontWeight: 800 }}>افتحها</a>
                            </span>,
                            { position: "bottom-center", autoClose: 12000 });
                        return;
                    }

                    if (noAdd) {
                        this.setState({ prBusy: false });
                        toast.error(`الوصل ${oid} أُضيف لكنه لم يظهر في القائمة — حدّث الصفحة`, { position: "bottom-center", autoClose: 7000 });
                        return;
                    }

                    // ===== فحص مسبق اختياري =====
                    //
                    // الإضافة تشترط status = 1، ورسالة الخادم عند الفشل
                    // «تأكد من صحة الطلب» لا تقول شيئاً. فنفحص قبلها.
                    //
                    // ⚠️ لكن الفحص **مشروط بوجود الحقل**: الخادم الأقدم
                    // لا يرسل status، وقراءته حينها تعطي undefined فيُرفض
                    // كل وصل برسالة «الحالة undefined» — حقلٌ غائب يتحوّل
                    // إلى منع قاطع. الغياب يعني «لا أعرف» لا «ممنوع»،
                    // فنمضي للإضافة ونترك الخادم يحكم.
                    const knowsStatus = (d.status !== undefined && d.status !== null);
                    if (knowsStatus && Number(d.status) !== 1) {
                        this.setState({ prBusy: false });
                        toast.error(`الوصل ${oid}: حالته لا تسمح بإضافته لقائمة راجع (الحالة ${d.status})`, { position: "bottom-center", autoClose: 7000 });
                        return;
                    }

                    this.prAddThenOpen(oid, !knowsStatus);
                    return;
                }

                const qty = {}, free = {};
                for (const it of (d.items || [])) { qty[it.orderItemId] = 0; free[it.orderItemId] = 0; }

                this.setState({
                    prBusy: false, prData: d, prOrderId: String(oid),
                    prPrice: '', prQty: qty, prFree: free, prDevs: [],
                });

                // اللوحة تُفتح تحت الشريط، وقد تكون خارج الشاشة بعد
                // الإضافة. إظهارها وتركيز الماسح يجعل المسح الخطوة
                // التالية مباشرةً بلا بحث عن الحقل.
                setTimeout(() => {
                    const box = document.getElementById('prPanelBox');
                    if (box && box.scrollIntoView) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 40);
                this.prFocus((d.items || []).some(it => (it.devices || []).length) ? 'prDeviceScan' : 'prOrderField');
            })
            .catch(err => {
                const msg = (err && err.response && err.response.data && err.response.data.message)
                    || `تعذّر فتح الوصل ${oid}`;
                this.setState({ prBusy: false });
                toast.error(msg, { position: "bottom-center", autoClose: 5000 });
            });
    }

    // إضافة الوصل لهذه القائمة ثم فتحه للراجع الجزئي.
    //
    // تستعمل نفس نقطة زر «إضافة» (users/list/add) — لا نسخة ثانية
    // من منطق الإضافة: نسختان تفترقان بصمت، وهذه تُغيّر حالة الطلب
    // إلى ٤ وتربطه بالقائمة.
    prAddThenOpen(oid, staleServer) {
        this.setState({ prBusy: true });
        axios.post(host + `users/list/add`,
            qs.stringify({ list_id: id, order_id: oid }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") } })
            .then(() => this.prRefreshMeta(id))
            .then(() => {
                toast.success(`أُضيف الوصل ${oid} للقائمة`, { position: "bottom-center", autoClose: 3000 });
                this.loadOrders(id);
                this.prOpenOrder(oid, true);
            })
            .catch(err => {
                const msg = (err && err.response && err.response.data && err.response.data.message)
                    || `تعذّرت إضافة الوصل ${oid} للقائمة`;
                this.setState({ prBusy: false });
                // الخادم الأقدم لا يرسل status ولا list_id، فلا يمكن للوحة
                // أن تقول أين الوصل ولا لماذا رُفض. نقول ذلك صراحةً بدل
                // ترك الفني أمام رسالة غامضة.
                toast.error(
                    staleServer
                        ? `${msg} — الباك إند المنشور قديم، أعد نشره لرسالة أدق (قد يكون الوصل في قائمة أخرى)`
                        : msg,
                    { position: "bottom-center", autoClose: staleServer ? 10000 : 7000 });
            });
    }

    // كل أجهزة الطلب المفتوح، مع بندها
    prAllDevices() {
        const out = [];
        const d = this.state.prData;
        if (!d) return out;
        for (const it of (d.items || [])) {
            for (const dev of (it.devices || [])) {
                out.push({ ...dev, orderItemId: it.orderItemId, component_name: it.component_name });
            }
        }
        return out;
    }

    // المسح — العدد يتحدّد هنا
    prScanDevice(code) {
        const raw = String(code || '').trim();
        if (!raw) return;

        const all = this.prAllDevices();
        const dev = this.resolveScan(all, raw);

        if (!dev) {
            toast.error(`«${raw}» ليس من أجهزة الوصل ${this.state.prOrderId}`, { position: "bottom-center", autoClose: 4000 });
            this.prFocus('prDeviceScan');
            return;
        }
        if (this.state.prDevs.some(x => x.id === dev.id)) {
            toast.warn(`الجهاز #${dev.id} ممسوح مسبقاً`, { position: "bottom-center", autoClose: 2500 });
            this.prFocus('prDeviceScan');
            return;
        }
        this.setState(prev => ({ prDevs: [...prev.prDevs, { ...dev, condition: 'ok' }] }));
        toast.success(`#${dev.id} · ${dev.composite_name || dev.sn}`, { position: "bottom-center", autoClose: 1800 });
        this.prFocus('prDeviceScan');
    }

    prRemoveDev(devId) {
        this.setState(prev => ({ prDevs: prev.prDevs.filter(x => x.id !== devId) }));
    }

    prSetCond(devId, cond) {
        this.setState(prev => ({
            prDevs: prev.prDevs.map(x => (x.id === devId ? { ...x, condition: cond } : x)),
        }));
    }

    // بناء السطور: الأجهزة من المسح، والمواد من الكمية المكتوبة
    prBuildLines() {
        const d = this.state.prData;
        if (!d) return { lines: [] };
        const lines = [];

        for (const it of (d.items || [])) {
            const scanned = this.state.prDevs.filter(x => x.orderItemId === it.orderItemId);
            const hasDevs = !!(it.is_phone && (it.devices || []).length > 0);

            // بند جهاز: العدد = عدد المسحات (+ وحدات بلا ربط إن وُجدت)
            // بند مواد:  العدد = المكتوب
            const freeMax = Math.max(Number(it.ordered_qty || 0) - (it.devices || []).length, 0);
            const free = hasDevs ? Math.min(Number(this.state.prFree[it.orderItemId]) || 0, freeMax) : 0;
            const qty = hasDevs ? (scanned.length + free) : (Number(this.state.prQty[it.orderItemId]) || 0);

            if (qty <= 0) continue;
            if (qty > Number(it.ordered_qty))
                return { err: `${it.component_name}: الراجع ${qty} أكبر من المطلوب ${it.ordered_qty}` };

            lines.push({
                orderItemId: it.orderItemId,
                componentsId: it.componentsId,
                is_phone: !!it.is_phone,
                returned_qty: qty,
                devices: scanned.map(x => ({ purchaseDeviceId: x.id, condition: x.condition })),
            });
        }
        return { lines };
    }

    prSubmit() {
        const { lines, err } = this.prBuildLines();
        if (err) { toast.error(err, { position: "bottom-center", autoClose: 4000 }); return; }
        if (!lines.length) { toast.error('امسح جهازاً راجعاً أو حدّد كمية مادة', { position: "bottom-center", autoClose: 4000 }); return; }
        if (this.state.prPrice === '' || this.state.prPrice === null) { toast.error('اكتب السعر بعد الراجع', { position: "bottom-center" }); return; }
        if (Number(this.state.prPrice) < 0) { toast.error('السعر لا يكون سالباً', { position: "bottom-center" }); return; }

        const orderId = Number(this.state.prOrderId);
        const header = { "Content-Type": "application/json", token: cookies.get("token") };
        const body = {
            orderId,
            new_price: Number(this.state.prPrice),
            created_by_name: cookies.get("name") || "",
            token: cookies.get("token"),
            lines,
        };

        this.setState({ prBusy: true });
        axios.post(host + `dashbord/list/partial-return/save`, body, { headers: header })
            .then(response => {
                const d = this.unwrapRes(response);
                this.prReset();
                this.componentDidMount();
                toast.success(d.msg || `سُجّل الراجع الجزئي للوصل ${orderId}`, { position: "bottom-center", autoClose: 5000 });
                this.prFocus('prOrderField');
            })
            .catch(error => {
                const msg = (error && error.response && error.response.data && error.response.data.message)
                    || 'فشل تسجيل الراجع';
                this.setState({ prBusy: false });
                toast.error(msg, { position: "bottom-center", autoClose: 6000 });
            });
    }

    // عدد أجهزة الراجع المسجَّل — يُستخدم للشارة والتقدم
    prReturnedDeviceCount(orderId) {
        const meta = this.prMeta && this.prMeta[orderId];
        const pr = meta && meta.partial_return;
        if (!pr) return null;
        let n = 0;
        for (const l of (pr.lines || [])) n += (l.devices || []).length;
        return n;
    }

    // ============================================================
    //  تركيبة ما رجع فعلاً — نصّاً
    //
    //  عمود «المنتج» هو order.notes2: نصّ ثابت كُتب لحظة إنشاء
    //  الطلب، لا يعرف شيئاً عن الراجع. في قائمة راجع يهمّ **ما وصل**
    //  لا ما خرج، فيُعرض الراجع أولاً والأصلي تحته مشطوباً.
    //
    //  ⚠️ عرضٌ فقط. لا يُمسّ orders_form_items: تعديل الكمية هناك
    //  يضيّع الأصل، وينهار معه order_from.cost لأن صيغته تضرب
    //  dw_price × ofi.count.
    // ============================================================
    prReturnedText(orderId) {
        const meta = this.prMeta && this.prMeta[orderId];
        const pr = meta && meta.partial_return;
        if (!pr) return null;
        const parts = (pr.lines || [])
            .filter(l => Number(l.returned_qty) > 0)
            .map(l => `${l.component_name} * ${l.returned_qty}`);
        return parts.length ? `( ${parts.join('  ·  ')} )` : null;
    }

    // كميات ما رجع لكل صنف — لملخّص المواد
    prReturnedQtyByName(orderId) {
        const meta = this.prMeta && this.prMeta[orderId];
        const pr = meta && meta.partial_return;
        if (!pr) return null;
        const out = {};
        for (const l of (pr.lines || [])) {
            const q = Number(l.returned_qty) || 0;
            if (q > 0) out[l.component_name] = (out[l.component_name] || 0) + q;
        }
        return out;
    }

    // إلغاء الراجع الجزئي — قبل «ادخال المخزن» فقط.
    // بعد التطبيق العدّ زاد والأجهزة رجعت، وسحبها يحتاج قائمة
    // «تحويل من المخزن» لا حذف سجل.
    cancelPartialReturn(orderId) {
        var header = { "Content-Type": "application/json", token: cookies.get("token") };
        axios.delete(host + `dashbord/list/partial-return/${orderId}`, {
            headers: header, data: { token: cookies.get("token") },
        })
            .then(() => {
                this.componentDidMount();
                toast.success('أُلغي الراجع ورجع السعر الأصلي', { position: "bottom-center", autoClose: 3000 });
            })
            .catch(error => {
                const msg = (error && error.response && error.response.data && error.response.data.message)
                    || 'فشل الإلغاء';
                toast.error(msg, { position: "bottom-center", autoClose: 5000 });
            });
    }

    // يحلّ الباركود الممسوح ضمن أجهزة البند وحده.
    // رقم الجهاز أولاً ثم السيريال — الباركود المطبوع هو purchase_device.id.
    resolveScan(devices, code) {
        const raw = String(code || '').trim();
        if (!raw) return null;
        for (let i = 0; i < devices.length; i++) {
            if (String(devices[i].id) === raw) return devices[i];
        }
        const up = raw.toUpperCase();
        for (let i = 0; i < devices.length; i++) {
            if (devices[i].sn && String(devices[i].sn).toUpperCase() === up) return devices[i];
        }
        return null;
    }

    onChangeD(value) {
        let count = document.getElementById(value).value;
        if (count > 0) { document.getElementById(value).value = Number(count) - 1; }
    }

    // ===== قارئ الجهاز الموحّد =====
    // يعتمد purchaseDeviceId حصراً (المخزن الجديد). النظام القديم (sana)
    // مُهمَل في هذه الصفحة عمداً — مصدر لبس ومشاكل.
    // يُرجع { id, name, orderItemId, info } أو null إن لم يكن سطر جهاز جديد.
    readDeviceFromIphone(iph) {
        if (!iph) return null;
        if (iph.purchaseDeviceId || iph.purchaseDevice) {
            const pd = iph.purchaseDevice || {};
            return {
                id: iph.purchaseDeviceId || pd.id,
                kind: 'purchase',
                name: pd.composite_name || pd.name || '',
                orderItemId: iph.ordersItems ? iph.ordersItems.id : null,
                info: pd,
            };
        }
        return null;
    }

    handleDeviceScan(scannedValue) {
        if (!scannedValue || scannedValue.trim() === '') return;
        const sanaId = Number(scannedValue.trim());
        const { rawOrders, scannedDevices } = this.state;

        if (scannedDevices[sanaId]) {
            toast.warn(`⚠ الجهاز ${sanaId} تم مسحه مسبقاً — طلب ${scannedDevices[sanaId].order_id}`, { position: "bottom-center", autoClose: 3000 });
            this.addScanLog(sanaId, null, 'duplicate', 'مسبقاً');
            this.clearScanField();
            return;
        }

        let found = false;
        for (let i = 0; i < rawOrders.length; i++) {
            const order = rawOrders[i];
            if (!order.packaging) continue;
            for (let p = 0; p < order.packaging.length; p++) {
                if (!order.packaging[p].iphone) continue;
                for (let ph = 0; ph < order.packaging[p].iphone.length; ph++) {
                    const iph = order.packaging[p].iphone[ph];
                    const dev = this.readDeviceFromIphone(iph);
                    if (dev && dev.id === sanaId) {
                        this.deviceCheckAPI(order.id, dev.id, dev.info);
                        found = true; break;
                    }
                }
                if (found) break;
            }
            if (found) break;
        }

        if (!found) {
            toast.error(`✗ الجهاز ${sanaId} غير موجود!`, { position: "bottom-center", autoClose: 4000 });
            this.addScanLog(sanaId, null, 'error', 'غير موجود');
        }
        this.clearScanField();
    }

    deviceCheckAPI(orderId, sanaId, deviceInfo) {
        var header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        axios.post(host + `users/rejctedList/device_check/${orderId}`, {}, { headers: header })
            .then(response => {
                const newScanned = { ...this.state.scannedDevices };
                newScanned[sanaId] = { order_id: orderId, matched: true, deviceInfo };
                const updatedOrders = this.state.orders.map(o => {
                    if (o.id === orderId) {
                        return { ...o, device_check: (o.device_check || 0) + 1 };
                    }
                    return o;
                });
                this.setState({
                    scannedDevices: newScanned,
                    matchedDevicesCount: Object.keys(newScanned).length,
                    orders: updatedOrders,
                });
                toast.success(`✓ جهاز ${sanaId} ← طلب ${orderId}`, { position: "bottom-center", autoClose: 2500 });
                this.addScanLog(sanaId, orderId, 'success', 'تم');
            })
            .catch(error => {
                console.log(error);
                toast.error(`فشل التحقق — ${sanaId}`, { position: "bottom-center", autoClose: 4000 });
                this.addScanLog(sanaId, orderId, 'error', 'فشل الاتصال');
            });
    }

    clearScanField() {
        const el = document.getElementById('deviceScanField');
        if (el) { el.value = ''; el.focus(); }
    }

    addScanLog(sanaId, orderId, status, message) {
        this.setState(prev => {
            const newLog = [{ time: moment().format('HH:mm:ss'), sanaId, orderId, status, message }, ...prev.scanLog].slice(0, 100);
            this.saveScanLog(newLog);
            return { scanLog: newLog };
        });
    }

    classifyOrders(rawOrders) {
        let totalPhoneDevices = 0;
        let preScanned = {};
        for (let i = 0; i < rawOrders.length; i++) {
            const order = rawOrders[i];
            // تجاهل طلبات الاستبدال
            if (order.replacement) continue;
            if (!order.packaging) continue;

            // الطلب ذو الراجع الجزئي: المتوقّع منه ما رجع فقط، وهو
            // مُطابَق سلفاً بالمسح لحظة التسجيل. إدخاله في المقام
            // بأجهزته كلها يجمّد التقدم دون ١٠٠٪ أبداً.
            const prMetaRow = this.prMeta && this.prMeta[order.id];
            const prRow = prMetaRow && prMetaRow.partial_return;
            if (prRow) {
                for (const l of (prRow.lines || [])) {
                    for (const dv of (l.devices || [])) {
                        if (!dv.device_id) continue;
                        totalPhoneDevices += 1;
                        preScanned[dv.device_id] = {
                            order_id: order.id, matched: true,
                            deviceInfo: `${dv.composite_name || ''} ${dv.sn || ''}`.trim(),
                        };
                    }
                }
                continue;
            }

            for (let p = 0; p < order.packaging.length; p++) {
                if (!order.packaging[p].iphone) continue;
                const phones = order.packaging[p].iphone;
                totalPhoneDevices += phones.length;
                const deviceCheckCount = order.device_check || 0;
                if (deviceCheckCount > 0) {
                    for (let ph = 0; ph < Math.min(deviceCheckCount, phones.length); ph++) {
                        const dev = this.readDeviceFromIphone(phones[ph]);
                        if (dev) {
                            preScanned[dev.id] = {
                                order_id: order.id, matched: true, deviceInfo: dev.info,
                            };
                        }
                    }
                }
            }
        }
        const merged = { ...this.state.scannedDevices, ...preScanned };
        this.setState({
            totalPhoneDevices, rawOrders,
            scannedDevices: merged,
            matchedDevicesCount: Object.keys(merged).length,
        });
    }

    getOrderDeviceStatus(order) {
        // طلبات الاستبدال تُهمل
        if (order.replacement) return { type: 'replacement' };

        // ===== الطلب ذو الراجع الجزئي =====
        // المطلوب منه ليس كل أجهزته بل **ما رجع منها**: الباقي عند
        // الزبون ولن يصل أبداً. بلا هذا يبقى الطلب «متبقي ٢ من ٤»
        // إلى الأبد ويمنع إدخال القائمة كلها.
        //
        // وهي مُطابَقة سلفاً: الأجهزة مُسحت لحظة تسجيل الراجع، فلا
        // معنى لمسحها مرة ثانية.
        const returned = this.prReturnedDeviceCount(order.id);
        if (returned !== null) {
            if (returned <= 0) return { type: 'home' };
            return { type: 'matched', total: returned, checked: returned, partial: true };
        }

        if (!order.isPhoneOrder || !order.deviceSanaIds || order.deviceSanaIds.length === 0) return { type: 'home' };
        const total = order.deviceSanaIds.length;
        const checked = order.device_check || 0;
        if (checked >= total) return { type: 'matched', total, checked };
        return { type: 'pending', total, checked, remaining: total - checked };
    }

    canSendToWarehouse() {
        const { orders } = this.state;
        for (let i = 0; i < orders.length; i++) {
            if (orders[i].replacement) continue;
            const status = this.getOrderDeviceStatus(orders[i]);
            if (status.type === 'pending') return false;
        }
        return true;
    }

    // ============================================================
    //  بيانات الراجع الجزئي — نداء مستقل
    //
    //  users/list/:id لا يحمّل iphone.purchaseDevice ولا iphone.ordersItems،
    //  فربط الجهاز بالبند مستحيل منه (كل بند جهاز يظهر «بلا جهاز مربوط»).
    //  والتعديل هناك يعني تسليم users.service.ts — ملف ضخم يتغيّر
    //  لأسباب أخرى، فتسليمه يمسح تعديلات لاحقة عليه.
    //
    //  فالبيانات تجيء من نقطة مستقلة وتُدمج هنا. الفشل لا يُسقط
    //  الصفحة: تبقى تعمل بلا زر الراجع.
    // ============================================================
    Orders(id) {
        this.prRefreshMeta(id)
            .catch(err => {
                // ⚠️ لا يُبتلع الخطأ.
                //
                // ابتلاعه يعطي «نجاحاً وهمياً»: اللوحة تُفتح بلا أجهزة،
                // فيؤشّر الفني الكمية وحدها، والخادم يرفض لأنه يرى
                // الأجهزة مربوطة في القاعدة — فيظهر الخلل كأنه في
                // البيانات وهو في الاتصال.
                this.prMeta = {};
                const st = err && err.response ? err.response.status : 0;
                this.prMetaError = st === 404 ? 'النقطة غير موجودة — أعد تشغيل الخادم'
                    : st === 500 ? 'خطأ في الخادم — تأكد من تشغيل alter_partial_return.sql على القاعدة الصحيحة'
                        : st ? `HTTP ${st}` : 'لا اتصال بالخادم';
                toast.error(`الراجع الجزئي معطّل: ${this.prMetaError}`, { position: "bottom-center", autoClose: 8000 });
            })
            .then(() => { this.loadOrders(id); });
    }

    // ============================================================
    //  فكّ غلاف الردّ
    //
    //  نقاط SendResponse ترجع { statusCode, message, error, data }،
    //  فالحقيقة في res.data.data لا res.data — وهو الاصطلاح المتّبع
    //  في بقية الشاشات (StockTransfer وغيرها).
    //
    //  ⚠️ قراءة res.data مباشرة لا ترمي خطأً: تعطي الغلاف، فتصير كل
    //  الحقول undefined **بصمت**. هذا ما جعل الخريطة فارغة دائماً،
    //  و«الحالة undefined»، و«ليس في هذه القائمة» لكل وصل.
    //
    //  نقبل الشكلين: النقاط الأقدم (users/list/:id) غير مغلّفة.
    // ============================================================
    unwrapRes(res) {
        const body = (res && res.data) || {};
        if (body && typeof body === 'object'
            && body.statusCode !== undefined && body.data !== undefined) return body.data;
        return body;
    }

    // تحديث خريطة الراجع وحدها — يرجع Promise ليُسلسَل عليه
    // (الإضافة للقائمة ثم الفتح تحتاج أن تنتظر التحديث).
    prRefreshMeta(listId) {
        var header = { "Content-Type": "application/json", token: cookies.get("token") };
        return axios.get(host + `dashbord/list/partial-return/list/${listId || id}`, { headers: header })
            .then(res => {
                const d = this.unwrapRes(res);
                const rows = (d && d.orders) || [];
                const map = {};
                for (let i = 0; i < rows.length; i++) map[rows[i].order_id] = rows[i];
                this.prMeta = map;
                this.prMetaError = null;
            });
    }

    loadOrders(id) {
        var header = { "Content-Type": "application/json", token: cookies.get("token") };
        const value = localStorage.getItem('rejcet_sort');
        let items_all = [];
        axios.get(host + `dashbord/items/get/all`, { headers: header })
            .then((response) => { for (let i = 0; i < response.data.items.length; i++) { items_all.push({ label: response.data.items[i].name, id: response.data.items[i].id, count: response.data.items[i].count }) } });

        let selectedItems = [];
        axios.get(host + `users/list/${id}?sort=${value}`, { headers: header })
            .then(res => {
                let isSend = res.data.list.is_send || false;
                if (isSend) {
                    const sd = document.getElementById('sendDiv'); if (sd) sd.style.display = 'none';
                    const sb = document.getElementById('seachBtn'); if (sb) sb.disabled = true;
                    const of = document.getElementById('orderFiled'); if (of) of.disabled = true;
                }
                let arr = [], items = res.data.list.orders, ordes2 = [], t_safee = 0, total_price = 0;
                let datesSummary = {}, dateLocationSummary = {}, itemsSummary = {};
                let replacementCount = 0;

                for (let i = 0; i < items.length; i++) {
                    let isPhoneOrder = false, deviceSanaIds = [];
                    if (items[i].ordersFormItems) { for (let j = 0; j < items[i].ordersFormItems.length; j++) { if (items[i].ordersFormItems[j].components && items[i].ordersFormItems[j].components.is_phone) isPhoneOrder = true; } }
                    if (items[i].packaging) { for (let p = 0; p < items[i].packaging.length; p++) { if (items[i].packaging[p].iphone) { for (let ph = 0; ph < items[i].packaging[p].iphone.length; ph++) { const dev = this.readDeviceFromIphone(items[i].packaging[p].iphone[ph]); if (dev) deviceSanaIds.push(dev.id); } } } }

                    const deviceCheckCount = items[i].device_check || 0;
                    const isDeviceScanned = isPhoneOrder && deviceCheckCount > 0;
                    if (items[i].replacement) replacementCount++;

                    let obj = {
                        i: i + 1,
                        date: moment(items[i].outDate).format('DD/MM/YYYY'),
                        id: items[i].id, phone: items[i].phone, name: items[i].name,
                        hav_done: items[i].hav_done, calls_d: '',
                        government: items[i].government, city: items[i].city,
                        price: items[i].price, safee: items[i].price - items[i].shping_price,
                        notes2: items[i].notes2,
                        calls: items[i].calls,
                        items_count: 1, update: 0, replacement: items[i].replacement,
                        notes: items[i].notes, createdAt: items[i].createdAt,
                        isPhoneOrder, deviceSanaIds,
                        device_check: deviceCheckCount,
                        hav: <Component initialState={{ isShown: false }}>
                            {({ state, setState }) => (
                                <Pane>
                                    <Dialog isShown={state.isShown} title='تعديل مواد الطلب' intent="warning" onCloseComplete={() => setState({ isShown: false })} confirmLabel="تعديل" cancelLabel="الغاء"
                                        onConfirm={() => {
                                            let upated_items = [];
                                            for (let index = 0; index < items[i].ordersFormItems.length; index++) {
                                                upated_items.push({ item_count: document.getElementById(`item${items[i].ordersFormItems[index].id}`).value, item_id: items[i].ordersFormItems[index].components.id, item_name: items[i].ordersFormItems[index].components.name, id: items[i].ordersFormItems[index].id });
                                            }
                                            let new_price = document.getElementById('InputTExtDash111').value;
                                            if (!new_price) { document.getElementById('InputTExtDash111').style.border = "2px solid red"; toast.error('تأكد من ادخال السعر', { position: "bottom-center" }); return -1; }
                                            this.recjeted(upated_items, Number(new_price), items[i].id); setState({ isShown: false });
                                        }}>
                                        <div style={{ padding: '15px' }}>
                                            <h5 style={{ fontSize: '15px', fontWeight: '700', marginBottom: '12px', color: T.ink }}>طلب رقم {items[i].id}</h5>
                                            {items[i].ordersFormItems.map((item, index) => (
                                                <div key={index} style={{ border: `1px solid ${T.line}`, borderRadius: '8px', padding: '12px', marginBottom: '10px', backgroundColor: T.wash }}>
                                                    <Row>
                                                        <Col xs={4}><Image src={ItemsImg} style={{ width: '70px', height: '70px', objectFit: 'cover', borderRadius: '8px' }} /></Col>
                                                        <Col xs={8}>
                                                            <h6 style={{ marginBottom: '8px', fontSize: '14px' }}>{item.components.name}</h6>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                                <button style={{ width: '32px', height: '32px', border: `1px solid ${T.line}`, backgroundColor: 'white', borderRadius: '6px', fontSize: '16px', cursor: 'pointer' }} onClick={() => this.onChangeD(`item${item.id}`)}>-</button>
                                                                <input type="text" value={item.count} id={`item${item.id}`} style={{ width: '45px', height: '32px', textAlign: 'center', border: `1px solid ${T.line}`, borderRadius: '6px' }} readOnly />
                                                                <button style={{ width: '32px', height: '32px', border: `1px solid ${T.line}`, backgroundColor: 'white', borderRadius: '6px', fontSize: '16px', opacity: 0.4 }} disabled>+</button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            ))}
                                            <input type="number" id="InputTExtDash111" placeholder="السعر الجديد" style={{ ...S.input, marginTop: '8px' }} />
                                        </div>
                                    </Dialog>
                                    <Edit style={{ cursor: 'pointer', fontSize: '18px', color: '#4299e1' }} onClick={() => setState({ isShown: true })} />
                                </Pane>
                            )}
                        </Component>,
                        partial_return: (() => {
                            // ===== التسجيل انتقل للماسح =====
                            // العدّ للأجهزة يُشتقّ من المسح، والمسح مكانه
                            // الماسح لا صفّ في جدول. الصفّ هنا للعرض
                            // والإلغاء فقط.
                            const meta = (this.prMeta && this.prMeta[items[i].id]) || null;

                            if (this.prMetaError) {
                                return (
                                    <span style={{ color: T.bad, fontSize: '15px', cursor: 'help' }}
                                        title={`الراجع الجزئي معطّل — ${this.prMetaError}`}>⚠</span>
                                );
                            }

                            const savedPR = meta ? meta.partial_return : null;

                            if (!savedPR) {
                                if (isSend) return <span style={{ color: T.ink3, fontSize: '12px' }} title="القائمة مقفلة">🔒</span>;
                                if (items[i].replacement) return <span style={{ color: T.ink3, fontSize: '12px' }} title="طلب استبدال — يُعالَج في رواجع الاستبدالات">—</span>;
                                return (
                                    <span style={{ color: T.ink3, fontSize: '15px', cursor: 'pointer' }}
                                        title="سجّله من زر «راجع جزئي» في الأعلى — العدد يتحدّد بالمسح"
                                        onClick={() => {
                                            this.setState({ prPanel: true });
                                            this.prReset();
                                            setTimeout(() => this.prOpenOrder(items[i].id), 80);
                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                        }}>↩</span>
                                );
                            }

                            const applied = !!savedPR.applied_at;
                            const canCancel = !applied && !isSend;

                            return (
                                <Component initialState={{ isShown: false }}>
                                    {({ state, setState }) => (
                                        <Pane>
                                            <Dialog isShown={state.isShown} title="الراجع الجزئي المسجَّل"
                                                intent={canCancel ? "danger" : "none"}
                                                onCloseComplete={() => setState({ isShown: false })}
                                                confirmLabel={canCancel ? "الغاء الراجع" : "اغلاق"}
                                                cancelLabel="رجوع"
                                                onConfirm={() => {
                                                    setState({ isShown: false });
                                                    if (canCancel) this.cancelPartialReturn(items[i].id);
                                                }}>
                                                <div style={{ padding: '12px' }}>
                                                    <h5 style={{ fontSize: '14px', fontWeight: '700', marginBottom: '10px', color: T.ink }}>
                                                        وصل {items[i].id} — السعر {savedPR.price_before} ← {savedPR.new_price}
                                                    </h5>
                                                    {savedPR.new_order_id ? (
                                                        <div style={{ border: '1px solid #bee3f8', backgroundColor: '#ebf8ff', borderRadius: '8px', padding: '10px', marginBottom: '10px' }}>
                                                            <div style={{ fontSize: '13px', fontWeight: '700', color: T.info }}>
                                                                تولّد الطلب <a href={`/order?id=${savedPR.new_order_id}`} style={{ color: T.info, textDecoration: 'underline' }}>#{savedPR.new_order_id}</a> بالباقي عند الزبون
                                                            </div>
                                                            <div style={{ fontSize: '12px', color: T.ink2, marginTop: '4px' }}>
                                                                سعره {savedPR.new_price} (المقبوض) · وهذا الطلب سعره {savedPR.price_before - savedPR.new_price} (ثمن ما رجع)
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div style={{ fontSize: '12px', color: T.ink2, marginBottom: '10px' }}>
                                                            لا باقي عند الزبون — لم يتولّد طلب جديد
                                                        </div>
                                                    )}
                                                    {(savedPR.lines || []).map((ln, li) => (
                                                        <div key={li} style={{ border: `1px solid ${T.line}`, borderRadius: '8px', padding: '10px', marginBottom: '8px', backgroundColor: T.wash }}>
                                                            <div style={{ fontSize: '13px', fontWeight: '700' }}>
                                                                {ln.component_name}{ln.is_phone ? ' 📱' : ''} — رجع {ln.returned_qty} من {ln.ordered_qty}
                                                            </div>
                                                            {(ln.devices || []).map((dv, di) => (
                                                                <div key={di} style={{ fontSize: '12px', color: dv.condition === 'damaged' ? '#c53030' : '#276749', marginTop: '4px' }}>
                                                                    #{dv.device_id} · {dv.sn} · {dv.condition === 'damaged' ? '🔧 تالف ← رواجع الاستبدالات' : '✓ سليم ← المخزن'}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ))}
                                                    <p style={{ fontSize: '12px', color: applied ? '#276749' : '#dd6b20', marginTop: '8px' }}>
                                                        {applied
                                                            ? `طُبِّق عند ادخال المخزن — قائمة ${savedPR.applied_list_id || ''}`
                                                            : isSend ? 'القائمة مقفلة'
                                                                : '⏳ العدّ والأجهزة تنتظر «ادخال المخزن»'}
                                                    </p>
                                                </div>
                                            </Dialog>
                                            <span style={{ cursor: 'pointer', color: applied ? '#38a169' : '#dd6b20', fontSize: '15px' }}
                                                title={applied ? "طُبِّق" : "سُجّل راجع جزئي — اضغط للمراجعة"}
                                                onClick={() => setState({ isShown: true })}>
                                                {applied ? '✅' : '📝'}
                                            </span>
                                        </Pane>
                                    )}
                                </Component>
                            );
                        })(),
                        items: <Component initialState={{ isShown: false }}>
                            {({ state, setState }) => (
                                <Pane>
                                    <Dialog isShown={state.isShown} title="مواد الطلب" intent="success" hasFooter={false} onCloseComplete={() => setState({ isShown: false })}>
                                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                            <thead><tr><th style={{ ...S.th, backgroundColor: '#c6f6d5', color: T.ok }}>العدد</th><th style={{ ...S.th, backgroundColor: '#c6f6d5', color: T.ok }}>المنتج</th></tr></thead>
                                            <tbody>{items[i].ordersFormItems.map((item, idx) => {
                                                const prMap = this.prReturnedQtyByName(items[i].id);
                                                const back = prMap ? (prMap[item.components.name] || 0) : null;
                                                // بعد الانقسام صار item.count هو الراجع،
                                                // والأصل محفوظ في count_before_return.
                                                const orig = (item.count_before_return != null)
                                                    ? item.count_before_return : item.count;
                                                return (
                                                    <tr key={idx}>
                                                        <td style={S.td}>
                                                            {back === null ? item.count : (
                                                                <span>
                                                                    <b style={{ color: back ? '#276749' : '#a0aec0' }}>{back}</b>
                                                                    <span style={{ color: T.ink3, fontSize: '11px' }}> من {orig}</span>
                                                                </span>
                                                            )}
                                                        </td>
                                                        <td style={S.td}>{item.components.name}</td>
                                                    </tr>
                                                );
                                            })}</tbody>
                                        </table>
                                    </Dialog>
                                    <CategoryIcon style={{ cursor: 'pointer', fontSize: '18px', color: '#ecc94b' }} onClick={() => setState({ isShown: true })} />
                                </Pane>
                            )}
                        </Component>,
                        edit_order: (this.prMeta && this.prMeta[items[i].id] && this.prMeta[items[i].id].partial_return) ? (
                            // تعديل الطلب يستبدل بنوده كلها. بعد الراجع
                            // الجزئي صارت البنود مقسومة بين طلبين وأجهزتها
                            // موزّعة عليهما، فالاستبدال يقطع الروابط بلا
                            // أثر يدلّ عليها. الإلغاء أولاً ثم التعديل.
                            <span style={{ color: T.ink3, fontSize: '12px' }} title="سُجّل راجع جزئي — ألغِه أولاً من عمود «راجع» إن أردت التعديل">🔒</span>
                        ) : isDeviceScanned ? (
                            <span style={{ color: T.ink3, fontSize: '12px' }} title="لا يمكن التعديل بعد مسح الجهاز">🔒</span>
                        ) : (
                            <Component initialState={{ isShown: false, selectedItems }}>
                                {({ state, setState }) => (
                                    <React.Fragment>
                                        <SideSheet isShown={state.isShown} title="تعديل الطلب" position={'left'} onCloseComplete={() => setState({ isShown: false })}>
                                            <Pane flex="1" overflowY="scroll" background="tint1" padding={16}>
                                                <div style={{ ...S.card, border: `1px solid ${T.line}` }}>
                                                    <h4 style={S.cardTitle}>اختر المنتجات</h4>
                                                    <MultiSelect items={items_all} selectedItems={state.selectedItems} onChange={(e) => setState({ selectedItems: e })} showSelectedItems={false} showSelectAll={false} />
                                                </div>
                                                {state.selectedItems.length > 0 && (
                                                    <div style={{ ...S.card, border: `1px solid ${T.line}` }}>
                                                        <h5 style={S.cardTitle}>المختارة</h5>
                                                        <table style={S.table}><thead><tr><th style={S.th}>المنتج</th><th style={S.th}>العدد</th></tr></thead>
                                                            <tbody>{state.selectedItems.map((item) => (<tr key={item.id}><td style={S.td}>{item.label}</td><td style={S.td}><Component initialState={{ value: 1 }}>{({ state: s, setState: ss }) => (<input type='number' id={item.id} value={s.value} onChange={(e) => ss({ value: e.target.value })} style={{ ...S.input, width: '70px', textAlign: 'center' }} />)}</Component></td></tr>))}</tbody>
                                                        </table>
                                                    </div>
                                                )}
                                                <input type="number" id="Editprice" placeholder="السعر مع التوصيل" style={{ ...S.input, marginBottom: '10px' }} />
                                                <textarea id="Editnotes" placeholder="ملاحظات" rows={3} style={{ ...S.input, marginBottom: '10px' }} />
                                                <button style={S.btn('#4299e1')} onClick={() => { let arry = []; for (let idx = 0; idx < state.selectedItems.length; idx++) { arry.push({ id: state.selectedItems[idx].id, name: state.selectedItems[idx].label, count: Number(document.getElementById(state.selectedItems[idx].id).value) }) } this.edit(arry, items[i].id) }}>تأكيد</button>
                                            </Pane>
                                        </SideSheet>
                                        <Edit style={{ cursor: 'pointer', fontSize: '18px', color: '#4299e1' }} onClick={() => setState({ isShown: true })} />
                                    </React.Fragment>
                                )}
                            </Component>
                        ),
                        text: <Component initialState={{ isShown: false }}>
                                {({ state, setState }) => (
                                    <Pane>
                                        <Dialog isShown={state.isShown} title="تأكيد الحذف" intent="danger" onCloseComplete={() => setState({ isShown: false })} confirmLabel="حذف" cancelLabel="الغاء"
                                            onConfirm={() => { setState({ isShown: false }); this.delete(items[i].id) }}>
                                            <p>حذف الطلب {items[i].id}؟</p>
                                        </Dialog>
                                        <DeleteForeverIcon onClick={() => setState({ isShown: true })} style={{ cursor: 'pointer', fontSize: '18px', color: '#fc8181' }} />
                                    </Pane>
                                )}
                            </Component>,
                    };

                    if (isSend) { obj.edit_order = <span style={{ color: T.ink3, fontSize: '12px' }}>🔒</span>; obj.text = <span style={{ color: T.ink3, fontSize: '12px' }}>🔒</span>; }
                    if (items[i].log.length > 0) { let arr2 = []; for (let idx = 0; idx < items[i].log.length; idx++) { arr2.push(<Badge bg="warning" text="dark" style={{ margin: '1px', fontSize: '10px' }} key={idx}>{items[i].log[idx].status}</Badge>) } obj.calls_d = <div>{arr2}</div>; }
                    var a = moment(moment(items[i].outDate)); var b = moment(res.data.list.createdAt);
                    if (b.diff(a, 'days') >= 14) { obj.date = <span style={{ color: '#fc8181', fontWeight: '700' }}>{moment(items[i].outDate).format('DD/MM/YYYY')}</span> } else { obj.date = moment(items[i].outDate).format('DD/MM/YYYY') }

                    let dateKey = moment(items[i].outDate).format('DD/MM/YYYY');
                    if (datesSummary[dateKey]) { datesSummary[dateKey]++ } else { datesSummary[dateKey] = 1 }
                    if (!dateLocationSummary[dateKey]) { dateLocationSummary[dateKey] = { total: 0, baghdad: 0, others: 0 } }
                    dateLocationSummary[dateKey].total++;
                    if (items[i].government && (items[i].government.includes('بغداد') || items[i].government.toLowerCase().includes('baghdad'))) { dateLocationSummary[dateKey].baghdad++ } else { dateLocationSummary[dateKey].others++ }
                    if (items[i].ordersFormItems) {
                        // ملخّص المواد يجيب «ما وصل المحل» لا «ما خرج».
                        // الطلب ذو الراجع الجزئي يُعدّ بكمياته الراجعة،
                        // والبند الذي بقي كله عند الزبون يُسقَط.
                        const prQtyMap = this.prReturnedQtyByName(items[i].id);
                        for (let j = 0; j < items[i].ordersFormItems.length; j++) {
                            let it = items[i].ordersFormItems[j];
                            let nm = it.components.name;
                            let ct = prQtyMap ? (prQtyMap[nm] || 0) : it.count;
                            if (ct <= 0) continue;
                            if (itemsSummary[nm]) { itemsSummary[nm].orderCount++; itemsSummary[nm].totalQuantity += ct; }
                            else { itemsSummary[nm] = { orderCount: 1, totalQuantity: ct }; }
                        }
                    }
                    t_safee = obj.safee + t_safee;
                    let price = items[i].price - items[i].shping_price;
                    let obj2 = { 'رقم الزبون': items[i].phone, 'المبلغ الصافي': price, 'المبلغ التوصيل': items[i].shping_price, 'المبلغ الكلي': items[i].price, 'المحافظة': items[i].government, 'رقم الوصل': items[i].id, 'التاريخ': moment(new Date()).format('DD/MM/') };
                    total_price = items[i].price + total_price;
                    arr.push(obj); ordes2.push(obj2);
                }
                this.setState({ orders_count: items.length, replacementCount, orders: arr, spin: false, t_safee, total_price, createdAt: moment(res.data.list.createdAt).format('DD/MM/YYYY'), ordes2, name: res.data.list.name, datesSummary, dateLocationSummary, itemsSummary, is_send: isSend });
                this.classifyOrders(items);
            })
            .catch(error => { console.log(error.response) });
    }

    handleChangeFrom = date => { this.setState({ from: date }) };
    handleChangeTo = date => { this.setState({ to: date }) };
    download() { const data = this.state.ordes2; const fileName = `${moment(new Date()).format('YYYY-MM-DD')}/${id}`; exportFromJSON({ data, fileName, exportType: exportFromJSON.types.xls }) }
    add(value) { axios.post(host + `users/list/add`, qs.stringify({ list_id: id, order_id: value }), { headers: { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") } }).then(() => { this.setState({ scannedDevices: {}, matchedDevicesCount: 0 }, () => this.Orders(id)); document.getElementById('orderFiled').value = ''; toast.success('تمت الاضافة', { position: "bottom-center", autoClose: 2500 }); }).catch(e => { toast.error("خطأ!", { position: "bottom-center", autoClose: 3000 }); console.log(e) }) }
    // ============================================================
    //  حذف الطلب من قائمة الراجع
    //
    //  ⚠️ الراجع الجزئي يُفكّ **أولاً**، وإلا خرج الوصل من القائمة
    //  وهو يحمل كميات الراجع لا كمياته الأصلية، وبقي الطلب المتولّد
    //  يتيماً بلا ما يشير إليه. users/list/:id تعيد hav_done و status
    //  فقط — لا الكميات ولا السعر ولا الطلب المتولّد.
    //
    //  والترتيب ليس تفضيلاً: لو فشل الفكّ (لأن القائمة أُدخلت للمخزن
    //  مثلاً) يجب ألّا يُحذف الوصل أصلاً.
    // ============================================================
    delete(value) {
        const header = { "Content-Type": "application/json", token: cookies.get("token") };
        const meta = this.prMeta && this.prMeta[value];
        const hasPR = !!(meta && meta.partial_return);

        const undo = hasPR
            ? axios.delete(host + `dashbord/list/partial-return/${value}`, { headers: header, data: { token: cookies.get("token") } })
            : Promise.resolve(null);

        undo
            .then(() => axios.delete(host + `users/list/${value}`, { headers: { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") } }))
            .then(() => {
                this.removeScanLogByOrderId(value);
                this.setState({ scannedDevices: {}, matchedDevicesCount: 0 }, () => this.Orders(id));
                toast.success(hasPR ? 'حُذف الوصل ورجعت كمياته وسعره، وحُذف الطلب المتولّد' : 'تم الحذف',
                    { position: "bottom-center", autoClose: hasPR ? 5000 : 2500 });
            })
            .catch(e => {
                const msg = (e && e.response && e.response.data && e.response.data.message) || 'فشل الحذف';
                toast.error(msg, { position: "bottom-center", autoClose: 6000 });
                console.log(e);
            });
    }

    render() {
        if (cookies.get("token")) {
            const canSend = this.canSendToWarehouse();
            const { orders, showDeviceScanner, totalPhoneDevices, matchedDevicesCount, scanLog, deviceFilter } = this.state;
            const pct = totalPhoneDevices > 0 ? Math.round((matchedDevicesCount / totalPhoneDevices) * 100) : 0;

            const filteredOrders = orders.filter(order => {
                if (deviceFilter === 'all') return true;
                const isPhone = order.isPhoneOrder && order.deviceSanaIds && order.deviceSanaIds.length > 0;
                return deviceFilter === 'phone' ? isPhone : !isPhone;
            });

            return (
                <Context.Consumer>
                    {ctx => (
                        <div className="lb" style={S.page}>
                            <style>{PAGE_CSS}</style>

                            {/* ── الترويسة ── */}
                            <div style={S.topBar}>
                                <div style={{ display: 'flex', alignItems: 'baseline', gap: '12px', flexWrap: 'wrap' }}>
                                    <h3 style={S.topTitle}>قائمة راجع #{id}</h3>
                                    <span style={{ fontSize: '15px', fontWeight: 700, color: '#A9BBD1' }}>
                                        {this.state.name}
                                    </span>
                                    <span style={{ fontSize: '12px', color: '#7D90A8', fontVariantNumeric: 'tabular-nums' }}>
                                        {this.state.createdAt}
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    {this.state.is_send
                                        ? <span className="lb-lock">🔒 مُدخلة للمخزن — للقراءة فقط</span>
                                        : <span className="lb-lock">✎ مفتوحة للتعديل</span>}
                                    <button style={S.btn('#a0aec0')} onClick={() => this.download()}>
                                        ⭳ تصدير Excel
                                    </button>
                                </div>
                            </div>

                            {/* ── الإحصاءات ── */}
                            <div style={S.statsBar}>
                                {[
                                    { v: this.state.orders_count || 0, l: 'الطلبات', c: T.ink },
                                    { v: this.state.replacementCount || 0, l: 'الاستبدالات', c: T.info },
                                    { v: this.state.t_safee || 0, l: 'الصافي', c: T.ok },
                                    { v: this.state.total_price || 0, l: 'الكلي', c: T.warn },
                                    { v: `${matchedDevicesCount}/${totalPhoneDevices}`, l: 'أجهزة ممسوحة', c: T.device },
                                ].map((s, i) => (
                                    <div key={i} style={S.statCard(s.c)}>
                                        <div style={S.statValue(s.c)}>{s.v}</div>
                                        <div style={S.statLabel}>{s.l}</div>
                                    </div>
                                ))}
                            </div>

                            {/* ── شريط الأدوات ── */}
                            <div className="lb-sec" style={{ padding: '12px 24px', display: 'flex',
                                gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>

                                {/* إضافة وصل */}
                                <div className="lb-group" style={{ flex: '0 1 340px', minWidth: '250px' }}>
                                    <input id="orderFiled" type="text" placeholder="رقم الوصل…" style={S.input}
                                        disabled={this.state.is_send}
                                        onKeyPress={(e) => { if (e.key === "Enter" && e.target.value) this.add(e.target.value) }} />
                                    <button id="seachBtn" style={{ ...S.btn('#48bb78'), ...(this.state.is_send ? S.btnDisabled : {}) }}
                                        disabled={this.state.is_send}
                                        onClick={() => { let v = document.getElementById('orderFiled').value; if (v) this.add(v) }}>
                                        <SearchIcon style={{ fontSize: '17px' }} /> إضافة
                                    </button>
                                </div>

                                {/* العرض */}
                                <div className="lb-group">
                                    <span style={S.statLabel}>العرض</span>
                                    <select style={S.select} defaultValue={localStorage.getItem("rejcet_sort") || "non"}
                                        onChange={(e) => { localStorage.setItem("rejcet_sort", e.target.value); window.location.reload(); }}>
                                        <option value="non">الترتيب الافتراضي</option>
                                        <option value="last">الأحدث أولاً</option>
                                        <option value="id">رقم الوصل</option>
                                    </select>
                                    <select value={deviceFilter} style={S.select}
                                        onChange={(e) => this.setState({ deviceFilter: e.target.value })}>
                                        <option value="all">كل الطلبات</option>
                                        <option value="phone">الأجهزة فقط</option>
                                        <option value="home">المنزلية فقط</option>
                                    </select>
                                    {deviceFilter !== 'all' && (
                                        <span style={{ fontSize: '12px', color: T.ink2, fontVariantNumeric: 'tabular-nums' }}>
                                            {filteredOrders.length} من {orders.length}
                                        </span>
                                    )}
                                </div>

                                {/* الأدوات */}
                                {!this.state.is_send && (
                                    <div className="lb-group">
                                        <span style={S.statLabel}>الاستلام</span>
                                        <button style={S.btn(showDeviceScanner ? '#fc8181' : '#9f7aea')}
                                            onClick={() => this.setState(prev => ({ showDeviceScanner: !prev.showDeviceScanner }))}>
                                            📱 {showDeviceScanner ? 'إغلاق الماسح' : 'مسح الأجهزة'}
                                            <span style={{ backgroundColor: 'rgba(255,255,255,0.22)', padding: '1px 8px',
                                                borderRadius: '999px', fontSize: '12px', fontVariantNumeric: 'tabular-nums' }}>
                                                {matchedDevicesCount}/{totalPhoneDevices}
                                            </span>
                                        </button>

                                        {/* الراجع الجزئي — مدخله الماسح لا صفّ الجدول */}
                                        {!this.prMetaError && (
                                            <button style={S.btn(this.state.prPanel ? '#fc8181' : '#dd6b20')}
                                                onClick={() => {
                                                    const open = !this.state.prPanel;
                                                    this.setState({ prPanel: open });
                                                    if (open) { this.prReset(); this.prFocus('prOrderField'); }
                                                }}>
                                                ↩ {this.state.prPanel ? 'إغلاق الراجع الجزئي' : 'راجع جزئي'}
                                            </button>
                                        )}
                                    </div>
                                )}


                                {/* ادخال المخزن */}
                                <div id="sendDiv" style={{ marginRight: 'auto' }}>
                                    <Component initialState={{ isShown: false, logding: false }}>
                                        {({ state, setState }) => (
                                            <Pane>
                                                <Dialog isShown={state.isShown} title="ادخال مخزني" intent="danger" isConfirmLoading={state.logding} onCloseComplete={() => setState({ isShown: false })} confirmLabel="تأكيد" cancelLabel="الغاء"
                                                    onConfirm={() => {
                                                        setState({ logding: true }); const urlParams = new URLSearchParams(window.location.search); let Getid = urlParams.get('id');
                                                        axios.post(host + `repair/return/warehouse/${Getid}`,
                                                            // ⚠️ الوسيط الثاني هو الجسم لا الإعدادات.
                                                            // كان `axios.post(url, { headers })` فيُرسل
                                                            // التوكن في الجسم ولا هيدر إطلاقاً — يشتغل
                                                            // بالحظ لأن المسار بلا حارس مصادقة.
                                                            { token: cookies.get("token") },
                                                            { headers: { "Content-Type": "application/json", token: cookies.get("token") } })
                                                            .then(() => { this.clearScanLogStorage(); this.setState({ scanLog: [] }); this.Orders(id); setState({ isShown: false, logding: false }); toast.success('تم الادخال للمخزن', { position: "bottom-center", autoClose: 3000 }); })
                                                            .catch(e => { this.Orders(id); setState({ logding: false }); toast.error("خطأ!", { position: "bottom-center", autoClose: 3000 }); console.log(e) })
                                                    }}>
                                                    {!canSend ? (
                                                        <div style={{ padding: '15px', backgroundColor: '#FDECE9', borderRadius: '8px', border: '1px solid #F3C4BB' }}>
                                                            <p style={{ color: T.bad, fontWeight: '700', margin: 0 }}>⚠ لا يمكن الادخال!</p>
                                                            <p style={{ color: T.bad, fontSize: '14px', margin: '8px 0 0' }}>يوجد أجهزة لم يتم مسحها بعد. يجب مسح جميع الأجهزة أولاً.</p>
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <p>هل انت متأكد من ادخال القائمة الى المخزن؟</p>
                                                            <p style={{ color: T.bad, fontSize: '13px' }}>⚠ لن تتمكن من التعديل بعد الإدخال</p>
                                                        </div>
                                                    )}
                                                </Dialog>
                                                <button style={{ ...S.btn(canSend ? '#4299e1' : '#a0aec0'), ...(canSend ? {} : S.btnDisabled) }}
                                                    onClick={() => { if (canSend) setState({ isShown: true }); else toast.warn('يجب مسح جميع الأجهزة أولاً!', { position: "bottom-center", autoClose: 3000 }); }}>
                                                    <DoneAllIcon style={{ fontSize: '18px' }} />
                                                    ادخال المخزن
                                                    {!canSend && <span style={{ fontSize: '11px' }}>⚠</span>}
                                                </button>
                                            </Pane>
                                        )}
                                    </Component>
                                </div>
                            </div>

                            {/* Scanner Section */}
                            {/* ============ لوحة الراجع الجزئي ============ */}
                            {this.state.prPanel && !this.state.is_send && (
                                <div style={{ padding: '14px 24px 0' }}>
                                <div id="prPanelBox" className="lb-panel">
                                    <div className="lb-panel-head">
                                        ↩ الراجع الجزئي
                                        <span style={{ fontWeight: 400, letterSpacing: 0, fontSize: '12px', color: T.ink3 }}>
                                            العدّ يُشتقّ من المسح لا يُكتب
                                        </span>
                                    </div>
                                    <div style={{ padding: '16px 18px' }}>

                                    {/* الخطوة ١ — رقم الوصل */}
                                    <div style={{ display: 'flex', gap: '10px', marginBottom: '14px', alignItems: 'center', flexWrap: 'wrap' }}>
                                        <span className="lb-step"><i>١</i> رقم الوصل</span>
                                        <input id="prOrderField" type="text" placeholder="رقم الوصل…" autoComplete="off"
                                            disabled={!!this.state.prData}
                                            style={{ ...S.scanInput, flex: '0 0 250px', fontSize: '19px', padding: '11px 15px', borderColor: T.warn, backgroundColor: this.state.prData ? '#EEF2F7' : '#FFF8EE' }}
                                            onKeyPress={(e) => { if (e.key === 'Enter' && e.target.value) this.prOpenOrder(e.target.value); }} />
                                        {!this.state.prData ? (
                                            <button style={{ ...S.btn('#dd6b20'), padding: '12px 24px' }} disabled={this.state.prBusy}
                                                onClick={() => { const v = document.getElementById('prOrderField'); if (v && v.value) this.prOpenOrder(v.value); }}>
                                                {this.state.prBusy ? '…' : 'فتح'}
                                            </button>
                                        ) : (
                                            <button style={{ ...S.btn('#a0aec0'), padding: '12px 24px' }}
                                                onClick={() => { this.prReset(); this.prFocus('prOrderField'); }}>
                                                وصل آخر
                                            </button>
                                        )}
                                        {!this.state.prData && (
                                            <span style={{ fontSize: '11px', color: T.warn }}>
                                                الوصل غير الموجود في القائمة يُضاف إليها تلقائياً
                                            </span>
                                        )}
                                        {this.state.prData && (
                                            <span style={{ fontSize: '14px', fontWeight: '700', color: T.ink }}>
                                                وصل {this.state.prData.order_id} — السعر الأصلي {this.state.prData.price}
                                            </span>
                                        )}
                                    </div>

                                    {this.state.prData && (
                                        <React.Fragment>
                                            {/* الخطوة ٢ — البنود */}
                                            <div style={{ marginBottom: '12px' }}>
                                                <div className="lb-step"><i>٢</i> ما الذي رجع؟</div>

                                                {(this.state.prData.items || []).map((it, idx) => {
                                                    const hasDevs = !!(it.is_phone && (it.devices || []).length > 0);
                                                    const scanned = this.state.prDevs.filter(x => x.orderItemId === it.orderItemId);
                                                    const freeMax = Math.max(Number(it.ordered_qty || 0) - (it.devices || []).length, 0);
                                                    const free = hasDevs ? Math.min(Number(this.state.prFree[it.orderItemId]) || 0, freeMax) : 0;
                                                    const shown = hasDevs ? scanned.length + free : (Number(this.state.prQty[it.orderItemId]) || 0);

                                                    return (
                                                        <div key={idx} style={{ backgroundColor: T.wash, border: `1px solid ${T.line}`, borderRadius: '9px', padding: '10px 13px', marginBottom: '6px', display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                                                            <span style={{ fontSize: '14px', fontWeight: '700', minWidth: '160px' }}>
                                                                {it.component_name}{it.is_phone ? ' 📱' : ''}
                                                            </span>
                                                            <span style={{ fontSize: '12px', color: T.ink2 }}>المطلوب {it.ordered_qty}</span>

                                                            {hasDevs ? (
                                                                <React.Fragment>
                                                                    {/* العدد مشتقّ من المسح — لا حقل يُكتب فيه */}
                                                                    <span style={{ fontSize: '12px', color: T.ink2 }}>رجع:</span>
                                                                    <span style={{ fontSize: '18px', fontWeight: '800', color: shown ? '#276749' : '#a0aec0', minWidth: '26px', textAlign: 'center' }}>{shown}</span>
                                                                    <span style={{ fontSize: '11px', color: T.ink3 }}>({scanned.length} بالمسح من {(it.devices || []).length} مربوط)</span>
                                                                    {freeMax > 0 && (
                                                                        <span style={{ fontSize: '11px', color: T.ink2, display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                            + بلا جهاز مربوط:
                                                                            <input type="number" min="0" max={freeMax} value={this.state.prFree[it.orderItemId] || 0}
                                                                                style={{ width: '52px', height: '26px', textAlign: 'center', border: `1px solid ${T.line}`, borderRadius: '6px' }}
                                                                                onChange={(e) => { const v = Number(e.target.value) || 0; this.setState(prev => ({ prFree: { ...prev.prFree, [it.orderItemId]: Math.min(v, freeMax) } })); }} />
                                                                            <span style={{ color: T.ink3 }}>من {freeMax}</span>
                                                                        </span>
                                                                    )}
                                                                </React.Fragment>
                                                            ) : (
                                                                <React.Fragment>
                                                                    <span style={{ fontSize: '12px', color: T.ink2 }}>الراجع:</span>
                                                                    {/* ⚠️ القيمة تُقرأ **قبل** setState.
                                                                        React 16 يعيد تدوير كائن الحدث، ودالة
                                                                        المُحدِّث تُنفَّذ بعد انتهاء المعالج —
                                                                        فيصير e.target = null داخلها. */}
                                                                    <input type="number" min="0" max={it.ordered_qty} value={this.state.prQty[it.orderItemId] || 0}
                                                                        style={{ width: '64px', height: '30px', textAlign: 'center', border: `1px solid ${T.line}`, borderRadius: '6px' }}
                                                                        onChange={(e) => { const v = Number(e.target.value) || 0; this.setState(prev => ({ prQty: { ...prev.prQty, [it.orderItemId]: v } })); }} />
                                                                    {it.is_phone && <span style={{ fontSize: '11px', color: T.warn }}>⚠ بلا جهاز مربوط</span>}
                                                                </React.Fragment>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>

                                            {/* الخطوة ٣ — مسح الأجهزة الراجعة */}
                                            {this.prAllDevices().length > 0 && (
                                                <div style={{ marginBottom: '12px' }}>
                                                    <div className="lb-step">
                                                        <i>٣</i> امسح الأجهزة الراجعة — العدد يتحدّد بالمسح
                                                    </div>
                                                    <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                                                        <input id="prDeviceScan" type="text" placeholder="📷 امسح باركود الجهاز الراجع…" autoComplete="off"
                                                            style={{ ...S.scanInput, borderColor: T.warn, backgroundColor: '#FFF8EE' }}
                                                            onKeyPress={(e) => { if (e.key === 'Enter' && e.target.value) this.prScanDevice(e.target.value); }} />
                                                        <button style={{ ...S.btn('#dd6b20'), padding: '14px 28px', fontSize: '16px', borderRadius: '10px' }}
                                                            onClick={() => { const v = document.getElementById('prDeviceScan'); if (v && v.value) this.prScanDevice(v.value); }}>
                                                            إضافة
                                                        </button>
                                                    </div>

                                                    {this.state.prDevs.length === 0 ? (
                                                        <div style={{ fontSize: '13px', color: T.ink3, padding: '8px 4px' }}>
                                                            لا جهاز ممسوح بعد — امسح ما وصلك فعلاً، ولا تكتب عدداً.
                                                        </div>
                                                    ) : (
                                                        <div style={{ backgroundColor: 'white', borderRadius: '10px', padding: '10px' }}>
                                                            {this.state.prDevs.map((dv, di) => (
                                                                <div key={di} style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', padding: '8px 10px', marginBottom: '5px', borderRadius: '8px', border: `1px solid ${dv.condition === 'damaged' ? '#feb2b2' : '#9ae6b4'}`, backgroundColor: dv.condition === 'damaged' ? '#fff5f5' : '#f0fff4' }}>
                                                                    <span style={{ fontSize: '14px', fontWeight: '800' }}>#{dv.id}</span>
                                                                    <span style={{ fontSize: '13px', color: T.ink2 }}>{dv.composite_name || dv.component_name}</span>
                                                                    <span style={{ fontSize: '12px', color: T.ink3 }}>{dv.sn}</span>
                                                                    <select value={dv.condition} style={{ height: '30px', border: `1px solid ${T.line}`, borderRadius: '6px', fontSize: '13px', marginRight: 'auto' }}
                                                                        onChange={(e) => this.prSetCond(dv.id, e.target.value)}>
                                                                        <option value="ok">سليم ← المخزن</option>
                                                                        <option value="damaged">تالف ← رواجع الاستبدالات</option>
                                                                    </select>
                                                                    <span style={{ cursor: 'pointer', color: T.bad, fontWeight: '800', fontSize: '16px' }}
                                                                        title="حذف من القائمة" onClick={() => this.prRemoveDev(dv.id)}>✕</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {/* الخطوة ٤ — السعر والتسجيل */}
                                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap', borderTop: `1px solid ${T.line}`, paddingTop: '13px' }}>
                                                <span className="lb-step"><i>٤</i> المبلغ المقبوض</span>
                                                <input type="number" placeholder="المقبوض من الزبون" value={this.state.prPrice}
                                                    style={{ width: '160px', height: '38px', textAlign: 'center', border: `2px solid ${T.warn}`, borderRadius: '8px', fontSize: '16px', fontWeight: '700', fontVariantNumeric: 'tabular-nums', fontFamily: 'inherit' }}
                                                    onChange={(e) => this.setState({ prPrice: e.target.value })} />
                                                <button style={{ ...S.btn('#38a169'), padding: '12px 30px', fontSize: '16px' }} disabled={this.state.prBusy}
                                                    onClick={() => this.prSubmit()}>
                                                    {this.state.prBusy ? '…' : '✔ تسجيل'}
                                                </button>
                                                <span style={{ fontSize: '11px', color: T.ink2, marginRight: 'auto' }}>
                                                    يتولّد طلب جديد بالباقي عند الزبون بهذا المبلغ · ويبقى هذا الوصل بالراجع بثمن ما رجع · التالف يذهب لرواجع الاستبدالات لا للمخزن
                                                </span>
                                            </div>
                                        </React.Fragment>
                                    )}
                                    </div>
                                </div>
                                </div>
                            )}

                            {showDeviceScanner && !this.state.is_send && (
                                <div style={{ padding: '14px 24px 0' }}>
                                <div className="lb-panel">
                                    <div className="lb-panel-head">
                                        📱 ماسح الأجهزة
                                        <span style={{ fontWeight: 400, letterSpacing: 0, fontSize: '12px', color: T.ink3 }}>
                                            كل الأجهزة لازم تُمسح قبل الإدخال للمخزن
                                        </span>
                                    </div>
                                    <div style={{ padding: '16px 18px' }}>
                                    {/* Progress */}
                                    <div style={{ marginBottom: '14px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                                            <span style={{ fontSize: '13px', fontWeight: '600', color: T.info }}>تقدم المسح</span>
                                            <span style={{ fontSize: '13px', fontWeight: '700', color: pct === 100 ? '#276749' : '#2b6cb0' }}>{pct}%</span>
                                        </div>
                                        <div style={S.progressBar(pct, '#4299e1')}>
                                            <div style={S.progressFill(pct, pct === 100 ? '#48bb78' : '#4299e1')}></div>
                                        </div>
                                    </div>
                                    {/* Scan Input */}
                                    <div style={{ display: 'flex', gap: '10px', marginBottom: '14px' }}>
                                        <input id="deviceScanField" type="text" placeholder="📷 امسح باركود الجهاز..." autoFocus
                                            style={S.scanInput}
                                            onKeyPress={(e) => { if (e.key === "Enter" && e.target.value) this.handleDeviceScan(e.target.value); }} />
                                        <button style={{ ...S.btn('#4299e1'), padding: '14px 28px', fontSize: '16px', borderRadius: '10px' }}
                                            onClick={() => { const v = document.getElementById('deviceScanField').value; if (v) this.handleDeviceScan(v); }}>
                                            مطابقة
                                        </button>
                                    </div>
                                    {/* Scan Log */}
                                    {scanLog.length > 0 && (
                                        <div style={{ backgroundColor: T.wash, border: `1px solid ${T.line}`, borderRadius: '10px', padding: '13px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                                <span style={S.cardTitle}>سجل المطابقة ({scanLog.length})</span>
                                                {scanLog.length > 8 && (
                                                    <button style={{ ...S.btn('#a0aec0'), padding: '4px 12px', fontSize: '12px' }}
                                                        onClick={() => this.setState(pv => ({ scanLogAll: !pv.scanLogAll }))}>
                                                        {this.state.scanLogAll ? 'أقلّ' : `عرض الكل (${scanLog.length})`}
                                                    </button>
                                                )}
                                            </div>
                                            {(this.state.scanLogAll ? scanLog : scanLog.slice(0, 8)).map((log, i) => (
                                                <div key={i} style={{
                                                    ...S.scanLogItem(log.status === 'warning' ? 'error' : log.status),
                                                    ...(log.status === 'warning' ? { backgroundColor: '#FDECE9', borderRight: '4px solid #ed8936' } : {})
                                                }}>
                                                    <span style={{ fontSize: '14px', color: T.ink2, minWidth: '30px', fontWeight: '700' }}>{log.time}</span>
                                                    {log.status === 'warning' ? (
                                                        <span style={{ fontWeight: '700', fontSize: '15px', color: T.warn }}>{log.message}</span>
                                                    ) : (
                                                        <React.Fragment>
                                                            <span style={{ fontWeight: '800', fontSize: '15px', color: T.ink }}>#{log.sanaId}</span>
                                                            {log.orderId && <span style={{ fontSize: '14px', color: T.ink2 }}>← وصل {log.orderId}</span>}
                                                            <span style={{ fontSize: '14px', fontWeight: '700', color: log.status === 'success' ? '#38a169' : log.status === 'error' ? '#e53e3e' : '#d69e2e' }}>{log.message}</span>
                                                        </React.Fragment>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    </div>
                                </div>
                                </div>
                            )}

                            {/* ── جدول الطلبات ── */}
                            <div style={{ padding: '14px 24px' }}>
                                {filteredOrders.length === 0 ? (
                                    <div className="lb-panel" style={{ padding: '46px 16px', textAlign: 'center',
                                        color: T.ink2, fontSize: '14px' }}>
                                        {orders.length === 0
                                            ? 'القائمة فارغة — أضف وصلاً من الأعلى'
                                            : 'ما فيه طلبات بهذا الفلتر'}
                                    </div>
                                ) : (
                                <div className="lb-tablewrap">
                                    <table style={S.table}>
                                        <thead>
                                            <tr>
                                                {COLS.map((c, i) => (
                                                    <th key={i} style={{
                                                        ...S.th, width: c.w,
                                                        textAlign: c.align || 'center',
                                                        ...(c.key === 'device' ? { color: T.device } : {})
                                                    }}>{c.t}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredOrders.map((order, i) => {
                                                const ds = this.getOrderDeviceStatus(order);
                                                let rowStyle = {};
                                                if (order.hav_done == true) rowStyle = S.rowHavDone;
                                                else if (ds.type === 'replacement') rowStyle = S.rowReplacement;
                                                else if (ds.type === 'matched') rowStyle = S.rowMatched;
                                                else if (ds.type === 'pending') rowStyle = S.rowPending;

                                                return (
                                                    <tr key={i} style={{ ...rowStyle, transition: 'background-color 0.3s' }}>
                                                        <td style={{ ...S.td, fontWeight: '800', fontSize: '15px' }}>{order.id}</td>
                                                        <td style={{ ...S.td, color: T.ink2, fontSize: '12.5px' }}>{order.date}</td>
                                                        <td style={S.td}>{order.government}</td>
                                                        <td style={{ ...S.td, fontWeight: '700' }}>{order.price}</td>
                                                        <td style={{ ...S.td, fontWeight: '700' }}>{order.safee}</td>
                                                        <td style={{ ...S.td, textAlign: 'right' }}>
                                                            {(() => {
                                                                const rt = this.prReturnedText(order.id);
                                                                if (!rt) return order.notes2;
                                                                return (
                                                                    <span>
                                                                        <span style={{ fontWeight: '700', color: T.ok }}>{rt}</span>
                                                                        <span style={{ display: 'block', fontSize: '11px', color: T.ink3, textDecoration: 'line-through', marginTop: '2px' }}>
                                                                            {order.notes2}
                                                                        </span>
                                                                    </span>
                                                                );
                                                            })()}
                                                        </td>
                                                        {/* عمود الجهاز */}
                                                        <td style={{ ...S.td, padding: '8px 6px' }}>
                                                            {ds.type === 'replacement' ? (
                                                                <span style={S.deviceBadgeReplacement}>🔄 استبدال</span>
                                                            ) : ds.type === 'home' ? (
                                                                <span style={{ color: T.ink3, fontSize: '14px' }}>—</span>
                                                            ) : ds.partial ? (
                                                                // المتوقّع ما رجع فقط — الباقي عند الزبون.
                                                                // وهو مُطابَق سلفاً: مُسح لحظة تسجيل الراجع.
                                                                <span style={S.deviceBadgeMatched}>↩ رجع {ds.total} جهاز</span>
                                                            ) : ds.type === 'matched' ? (
                                                                order.deviceSanaIds.map((sid, idx) => (
                                                                    <span key={idx} style={S.deviceBadgeMatched}>✓ {sid}</span>
                                                                ))
                                                            ) : (
                                                                <span style={S.deviceBadgePending}>
                                                                    📱 متبقي {ds.remaining} من {ds.total}
                                                                </span>
                                                            )}
                                                        </td>
                                                        <td style={S.td}>{order.calls ? <span style={{ color: T.bad, fontWeight: '800', fontSize: '15px' }}>{order.calls}</span> : ''}</td>
                                                        <td style={{ ...S.td, textAlign: 'right', color: T.ink2, fontSize: '12.5px' }}>{order.calls_d}</td>
                                                        <td style={{ ...S.td, textAlign: 'right', color: T.ink2, fontSize: '12.5px' }}>{order.notes}</td>
                                                        <td style={S.td}>{order.items}</td>
                                                        {/* راجع · تعديل · حذف بعمود واحد بدل ثلاثة */}
                                                        <td style={S.td}>
                                                            <span className="lb-actions">
                                                                {order.partial_return}
                                                                {order.edit_order}
                                                                {order.text}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                )}

                                {/* دليل ألوان الصفوف */}
                                {filteredOrders.length > 0 && (
                                    <div style={{ display: 'flex', gap: '18px', flexWrap: 'wrap',
                                        marginTop: '10px', fontSize: '12px', color: T.ink2 }}>
                                        {[
                                            { c: T.ok, t: 'أجهزته ممسوحة' },
                                            { c: T.bad, t: 'ينتظر المسح' },
                                            { c: T.warn, t: 'منجَز سابقاً' },
                                            { c: T.info, t: 'استبدال' },
                                        ].map((x, i) => (
                                            <span key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                                <i style={{ width: '3px', height: '13px', background: x.c, borderRadius: '2px' }} />
                                                {x.t}
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* ── الملخّصات ── */}
                            <div style={{ padding: '0 24px 26px', display: 'flex', gap: '14px', flexWrap: 'wrap' }}>
                                {/* ملخص التواريخ */}
                                {this.state.dateLocationSummary && Object.keys(this.state.dateLocationSummary).length > 0 && (
                                    <div style={{ ...S.card, flex: '1', minWidth: '350px' }}>
                                        <div style={S.cardTitle}>ملخّص حسب التاريخ</div>
                                        <table style={S.table}>
                                            <thead><tr>
                                                <th style={S.th}>التاريخ</th><th style={S.th}>بغداد</th><th style={S.th}>محافظات</th><th style={S.th}>الكلي</th>
                                            </tr></thead>
                                            <tbody>
                                                {Object.entries(this.state.dateLocationSummary).sort((a, b) => moment(a[0], 'DD/MM/YYYY') - moment(b[0], 'DD/MM/YYYY')).map(([date, data], idx) => (
                                                    <tr key={idx}>
                                                        <td style={{ ...S.td, fontWeight: '700' }}>{date}</td>
                                                        <td style={{ ...S.td, color: T.warn, fontWeight: '700' }}>{data.baghdad}</td>
                                                        <td style={{ ...S.td, color: T.device, fontWeight: '700' }}>{data.others}</td>
                                                        <td style={{ ...S.td, color: T.ok, fontWeight: '700' }}>{data.total}</td>
                                                    </tr>
                                                ))}
                                                <tr style={{ backgroundColor: T.wash }}>
                                                    <td style={{ ...S.td, fontWeight: '700', borderTop: `1px solid ${T.line}` }}>المجموع</td>
                                                    <td style={{ ...S.td, fontWeight: '700', color: T.warn, borderTop: `1px solid ${T.line}` }}>{Object.values(this.state.dateLocationSummary).reduce((s, d) => s + d.baghdad, 0)}</td>
                                                    <td style={{ ...S.td, fontWeight: '700', color: T.device, borderTop: `1px solid ${T.line}` }}>{Object.values(this.state.dateLocationSummary).reduce((s, d) => s + d.others, 0)}</td>
                                                    <td style={{ ...S.td, fontWeight: '700', color: T.ok, borderTop: `1px solid ${T.line}` }}>{this.state.orders_count}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                )}

                                {/* ملخص المواد */}
                                {this.state.itemsSummary && Object.keys(this.state.itemsSummary).length > 0 && (
                                    <div style={{ ...S.card, flex: '1', minWidth: '300px' }}>
                                        <div style={S.cardTitle}>ملخّص المواد</div>
                                        <table style={S.table}>
                                            <thead><tr>
                                                <th style={S.th}>المادة</th><th style={S.th}>طلبات</th><th style={S.th}>كمية</th>
                                            </tr></thead>
                                            <tbody>
                                                {Object.entries(this.state.itemsSummary).sort((a, b) => b[1].totalQuantity - a[1].totalQuantity).map(([name, data], idx) => (
                                                    <tr key={idx}>
                                                        <td style={{ ...S.td, fontWeight: '600' }}>{name}</td>
                                                        <td style={{ ...S.td, color: T.bad, fontWeight: '700' }}>{data.orderCount}</td>
                                                        <td style={{ ...S.td, color: T.ok, fontWeight: '700' }}>{data.totalQuantity}</td>
                                                    </tr>
                                                ))}
                                                <tr style={{ backgroundColor: T.wash }}>
                                                    <td style={{ ...S.td, fontWeight: '700', borderTop: `1px solid ${T.line}` }}>المجموع</td>
                                                    <td style={{ ...S.td, fontWeight: '700', color: T.bad, borderTop: `1px solid ${T.line}` }}>{Object.values(this.state.itemsSummary).reduce((s, d) => s + d.orderCount, 0)}</td>
                                                    <td style={{ ...S.td, fontWeight: '700', color: T.ok, borderTop: `1px solid ${T.line}` }}>{Object.values(this.state.itemsSummary).reduce((s, d) => s + d.totalQuantity, 0)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>

                            <ToastContainer position="bottom-center" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick rtl pauseOnHover />
                        </div>
                    )}
                </Context.Consumer>
            )
        } else { return (<Login />) }
    }
}

export default Selles_Reports;